var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkbox", on: { click: _vm.change } }, [
    _c("div", { staticClass: "check", class: { enabled: _vm.value } }),
    _vm._v(" "),
    _c("div", { staticClass: "text" }, [_vm._v(_vm._s(_vm.label))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }